"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ArrowIcon_1 = require("./ArrowIcon");
const useDisclosureContext_1 = require("./useDisclosureContext");
const color_1 = require("../../constants/color");
const theme_1 = require("../../constants/theme");
const ExpandIcon = styled_1.default.div({
    fontSize: 24,
    marginRight: 12,
    textAlign: 'center',
    width: 18,
});
const HeaderElement = styled_1.default.div((props) => ({
    alignItems: 'center',
    backgroundColor: props.floating ? undefined : color_1.Color.WHITE,
    border: props.floating ? undefined : theme_1.theme.border.style.thin,
    borderRadius: theme_1.theme.border.radius.normal,
    borderBottomLeftRadius: props.isOpen ? 0 : undefined,
    borderBottomRightRadius: props.isOpen ? 0 : undefined,
    boxShadow: props.isOpen && !props.floating ? theme_1.theme.boxShadow.elevated : undefined,
    color: props.floating ? color_1.Color.BLUE : undefined,
    cursor: 'pointer',
    display: 'flex',
    fontSize: props.floating ? 20 : undefined,
    fontWeight: theme_1.theme.font.weight.bold,
    overflow: 'hidden',
    padding: props.floating ? undefined : 20,
    paddingBottom: props.floating ? 16 : 20,
    paddingTop: props.floating ? 16 : 20,
    position: 'relative',
    userSelect: 'none',
    '&:hover': {
        background: color_1.Color.LIGHT_GREY,
    },
}));
const Header = ({ children, icon }) => {
    const { floating, isOpen, toggleIsOpen } = (0, useDisclosureContext_1.useDisclosureContext)();
    return ((0, jsx_runtime_1.jsxs)(HeaderElement, { floating: floating, isOpen: isOpen, onClick: toggleIsOpen, children: [icon &&
                (floating ? ((0, jsx_runtime_1.jsx)(ExpandIcon, { children: isOpen ? '–' : '+' })) : ((0, jsx_runtime_1.jsx)(ArrowIcon_1.ArrowIcon, { isOpen: isOpen }))), children] }));
};
exports.Header = Header;
